import {
    StaircaseTurnShapeId,
    StaircaseLimonShapeId,
    StaircaseRiserShapeId,
    StaircaseOptionShapeId,
    WindowShapeId,
    OpeningShapeId,
    StaircaseObstacleShapeId,
} from '@core/constants/Shape';
import { MaterialId } from '@core/constants/Material';
import { FieldDimensionId } from '@core/constants/FieldDimension';
import {
    IFormFieldShape,
    IFormFieldMaterial,
    IFormFieldMaterialComposite,
    IFormFieldShapeQuantities,
    IFormFieldDimension,
    IFormInputType,
    IDimensionUnit,
} from '../../../interfaces/Form';
import {
    allMarbleAndStones,
    allGlasses,
    allConcretes,
    allWoods,
    allMetals,
    getMaterialsWithExceptions,
} from './materialGroups';

export const fieldsStaircaseSideTurn: IFormFieldShape = {
    value   : undefined,
    options : [
        StaircaseTurnShapeId.StaircaseQuarterTurnLeft,
        StaircaseTurnShapeId.StaircaseQuarterTurnRight,
    ],
    required: true,
};

export const fieldsStaircaseLimon: IFormFieldShape = {
    value   : undefined,
    options : [
        StaircaseLimonShapeId.CentralLimon,
        StaircaseLimonShapeId.LateralLimon,
    ],
    required: true,
};

export const fieldsStaircasePlainSteps: IFormFieldShape = {
    value   : undefined,
    options : [
        StaircaseRiserShapeId.StaircaseWithoutRisers,
        StaircaseRiserShapeId.StaircaseWithRisers,
    ],
    required: true,
};

export const fieldsStaircaseMaterial: IFormFieldMaterial = {
    material: {
        value   : undefined,
        options : getMaterialsWithExceptions(
            [
                ...allWoods,
                ...allMetals,
                ...allMarbleAndStones,
                ...allGlasses,
                ...allConcretes,
            ],
            [
                MaterialId.DriftWood,
                MaterialId.DriftWoodRecycled,
                MaterialId.Garapa,
                MaterialId.Aluminum,
                MaterialId.Brass,
                MaterialId.SheetMetal,
                MaterialId.StainlessSteel,
                MaterialId.Zinc,
            ],
        ),
        required: true,
    },
};

export const fieldsStaircaseMaterialOptional = {
    ...fieldsStaircaseMaterial,
    material: {
        ...fieldsStaircaseMaterial.material,
        required: false,
    },
};

export const fieldsStaircaseGuardMaterialComposite: IFormFieldMaterialComposite = {
    materialPrimary   : fieldsStaircaseMaterialOptional,
    materialSecondary : fieldsStaircaseMaterialOptional,
};

export const fieldsStaircaseLightRamp: IFormFieldShapeQuantities = {
    [StaircaseOptionShapeId.LightRamp]: {
        value : undefined,
        min   : 0,
        max   : 1,
    },
    [StaircaseOptionShapeId.LightedSteps]: {
        value : undefined,
        min   : 0,
        max   : 1,
    },
    [StaircaseOptionShapeId.IntegratedStorage]: {
        value : undefined,
        min   : 0,
        max   : 1,
    },
};

export const fieldsStepsDimension: IFormFieldDimension = {
    [FieldDimensionId.Length]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 100,
        range        : { min: 700, max: 1500 },
        required     : true,
        defaultValue : 800,
    },
};

export const fieldsStaircaseDimension: IFormFieldDimension = {
    [FieldDimensionId.HeightStaircase]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 100,
        range        : { min: 1600, max: 3000 },
        required     : true,
        defaultValue : 2200,
    },
    [FieldDimensionId.WidthStaircase]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 100,
        range        : { min: 600, max: 1200 },
        required     : true,
        defaultValue : 800,

    },
    [FieldDimensionId.LengthStaircase]: {
        value        : undefined,
        type         : IFormInputType.Range,
        unit         : IDimensionUnit.Centimeters,
        step         : 100,
        range        : { min: 1500, max: 4000 },
        required     : true,
        defaultValue : 2000,
    },
};

export const fieldsStaircaseObstacle: IFormFieldShapeQuantities = {
    [WindowShapeId.SingleWindow]: {
        value : undefined,
        min   : 0,
        max   : 1,
    },
    [OpeningShapeId.SlidingDoors]: {
        value : undefined,
        min   : 0,
        max   : 1,
    },
    [StaircaseObstacleShapeId.Radiator]: {
        value : undefined,
        min   : 0,
        max   : 1,
    },
};
